/** Local demonstration of the existing calendar contract: consume the selected reservation once. */
export function applyDemoCheckIn(
  workspace: {
    appointments: {
      id: string
      customerId: string
      status: string
      statusLabel: string | null
      creditState: string | null
      creditStateLabel: string | null
    }[]
    credits: Record<string, { purchased: number; consumed: number }>
  },
  appointmentId: string,
  customerId: string,
) {
  const appointment = workspace.appointments.find(
    (a) => a.id === appointmentId && a.customerId === customerId,
  )
  if (!appointment) throw new Error('Dieser Termin wurde nicht gefunden.')
  if (appointment.creditState === 'consumed')
    throw new Error(
      'Dieser Termin wurde bereits eingecheckt. Es wurde genau eine Behandlung verbraucht.',
    )
  const credit = workspace.credits[customerId]
  if (appointment.creditState !== 'reserved' || !credit || credit.purchased <= credit.consumed)
    throw new Error('Für diesen Termin ist kein verfügbares Behandlungskontingent vorhanden.')
  if (appointment.status !== 'booked') throw new Error('Dieser Termin ist nicht mehr gebucht.')
  appointment.status = 'checked_in'
  appointment.statusLabel = 'Eingecheckt'
  appointment.creditState = 'consumed'
  appointment.creditStateLabel = 'Verbraucht'
  credit.consumed += 1
  return appointment
}
